import { render, staticRenderFns } from "./CustomerActWithExcel.vue?vue&type=template&id=24c1fb2a&"
import script from "./CustomerActWithExcel.vue?vue&type=script&lang=js&"
export * from "./CustomerActWithExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports